import useAppStore from "@/context/store";
import { computeColumn } from "@/context/useWidthCompute";
import useOnceInViewport from "@/utils/hooks/useOnceInViewport";
import { useLocalStorageState } from "ahooks";
import { Tabs } from "antd";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import styles from "../index.module.less";
import PinRecommendPinList from "../PinRecommendPinList";
import PinRelatedBoardList from "../PinRelatedBoardList";
function Recommend({
  isModal,
  pin,
  relatedBoards,
  similiarList,
  showSimilarList,
  searchWord,
}) {
  const RecommendType = useMemo(() => {
    return {
      pin: "pin",
      board: "board",
    };
  }, []);

  const { headerHeight } = useAppStore(({ headerHeight }) => ({
    headerHeight,
  }));
  //推荐导航栏高度
  const navHeight = 43;
  // 搜索栏高度
  const searchHeight = 80;
  // 推荐列表最小高度需要减去的部分
  const reduceHeight = useMemo(() => {
    let height = 0;
    if (!isModal) {
      height = headerHeight + searchHeight + navHeight;
    } else {
      // 弹窗情况下
      height = navHeight + 70;
    }
    return height;
  }, [headerHeight, isModal]);
  const [userRecommendType, setUserRecommendType] = useLocalStorageState(
    "PIN_DETAIL_RECOMMEND_TYPE",
    {
      defaultValue: RecommendType.board,
    }
  );
  const [recommendType, setRecommendType] = useState(RecommendType.board);

  const isUserTabChangeRef = useRef(false); // 用于标记是否是用户切换Tab

  const containerRef = useRef(null);

  const inViewport = useOnceInViewport(containerRef);

  const { TabPane } = Tabs;
  useEffect(() => {
    if (RecommendType[userRecommendType]) {
      setRecommendType(userRecommendType);
    } else {
      // 兼容其他tab的数据类型
      setRecommendType(RecommendType.board);
    }
  }, [RecommendType, userRecommendType]);
  // 用户主动切换Tab情况
  const userSelectTab = (tab) => {
    // 切换tab滚动到初始位置
    let target = document.querySelector("#pin_detail");
    // 获取dom元素的可视高度 + nav到详情的距离
    let top = target.clientHeight + 55;
    // 判断是否为弹窗
    if (isModal) {
      let modalDom = document.querySelector(".pinDetailModal");
      // 如果当前滚动距离小于推荐导航置顶距离，则不进行滚动
      modalDom.scrollTop > top &&
        modalDom.scrollTo({
          top,
        });
    } else {
      // 如果当前滚动距离小于推荐导航置顶距离，则不进行滚动
      window.scrollY > top &&
        window.scrollTo({
          top,
        });
    }
    isUserTabChangeRef.current = true;

    setUserRecommendType(tab);
    setRecommendType(tab);
  };
  // 默认加载同在画板为空的情况，切换到Tab：为你推荐
  const relatedListLoaded = useCallback((list) => {
    if (list.length === 0 && !isUserTabChangeRef.current) {
      setRecommendType("pin");
    }
  }, []);

  const column = useMemo(() => {
    if (isModal) {
      return computeColumn({
        width: Math.max(window.innerWidth, 1120),
      });
    }
  }, [isModal]);

  return (
    <>
      <div className={styles.list} ref={containerRef}>
        <div
          className={`${styles.wrapper} calculateWrapper`}
          style={column ? { width: column.wrapperWidth } : {}}
        >
          <Tabs
            className={styles.tab}
            // destroyInactiveTabPane={true}
            activeKey={recommendType}
            onChange={userSelectTab}
            tabBarStyle={{ top: isModal ? -1 : headerHeight - 1 }}
            centered
          >
            <TabPane tab="同在画板" key={RecommendType.board}>
              <div
                data-content-source="推荐画板"
                style={{ minHeight: `calc(100vh - ${reduceHeight}px)` }}
              >
                {recommendType === RecommendType.board &&
                  pin?.pin_id &&
                  inViewport && (
                    <PinRelatedBoardList
                      onFirstLoad={relatedListLoaded}
                      pinId={pin?.pin_id}
                      isModal={isModal}
                      initList={relatedBoards}
                      similiarList={similiarList}
                      showSimilarList={showSimilarList}
                      customColumn={column?.num}
                    />
                  )}
              </div>
            </TabPane>
            <TabPane tab="为你推荐" key={RecommendType.pin}>
              <div
                data-content-source="为你推荐"
                style={{ minHeight: `calc(100vh - ${reduceHeight}px)` }}
              >
                {recommendType === RecommendType.pin &&
                  pin?.pin_id &&
                  inViewport && (
                    <PinRecommendPinList
                      pinId={pin?.pin_id}
                      isModal={isModal}
                      fileId={pin?.file_id}
                      similiarList={similiarList}
                      showSimilarList={showSimilarList}
                      customColumn={column?.num}
                    />
                  )}
              </div>
            </TabPane>
          </Tabs>
        </div>
      </div>
    </>
  );
}
export default memo(Recommend);
